<template>
    <div>
        <div class="banner">
            <!-- Logo -->
            <div class="row">
            <div class="col-12 logo">
                <!-- <img :src="getDonationData && getDonationData.page_header_icon_1" alt="World For All Logo" class="me-3"> -->
                <img src="https://tss-static-images.gumlet.io/WFA.svg" alt="World For All Logo" class="me-3">
            </div>
            </div>
            <!-- Desktop Layout -->
            <div class="row d-none d-md-flex align-items-center banner-section">
            <!-- Left Side -->
            <div class="col-md-6">
                <h1 class="heading">{{getDonationData &&  getDonationData.page_header_title}}</h1>
                <!-- <p class="description">{{getDonationData &&  getDonationData.page_header_description}}</p> -->
                <p class="description" v-html="getDonationData && getDonationData.page_header_description"></p>
                <a 
                    :href="getDonationData && getDonationData.page_header_button_redirect_link" 
                    target="_blank" 
                    class="donate-button-link"
                >
                    <button class="donate-button" @click="donate()">
                        {{ getDonationData && getDonationData.page_header_button_text }}
                    </button>
                </a>
            </div>
            <!-- Right Side Images -->
            <div class="col-md-6 image-grid">
                <div class="row">
                <div class="col-6 mb-3 dogs-restling">
                    <img :src="getDonationData && getDonationData.page_header_image_2" alt="Dogs resting">
                </div>
                <div class="col-6 mb-3 two-dog-cuddling">
                    <img :src="getDonationData && getDonationData.page_header_image_1" alt="Two dogs cuddling">
                </div>
                <div class="col-7 cat-care">
                    <img  :src="getDonationData && getDonationData.page_header_image_3"alt="Cat being cared for">
                </div>
                </div>
            </div>
            </div>
            <!-- Mobile Layout -->
            <div class="row d-flex d-md-none">
            <!-- Images -->
            <div class="col-12 image-grid ml-2">
                <div class="row">
                <div class="col-6 mb-2 dogs-restling">
                    <img :src="getDonationData && getDonationData.page_header_image_2" alt="Dogs resting">
                </div>
                <div class="col-6 mb-3 two-dog-cuddling">
                    <img :src="getDonationData && getDonationData.page_header_image_1" alt="Two dogs cuddling">
                </div>
                <div class="col-8 cat-care">
                    <img :src="getDonationData && getDonationData.page_header_image_3"alt="Cat being cared for" ref="imageToScroll">
                </div>
                </div>
            </div>
            <!-- Heading -->
            <div class="col-12 heading" id="campain-info" ref="headingToScroll">
                <h1>{{getDonationData &&  getDonationData.page_header_title}}</h1>
            </div>
            <!-- Description -->
            <div class="col-12 description">
                <p class="description" v-html="getDonationData && getDonationData.page_header_description"></p>
                <!-- <p>{{getDonationData &&  getDonationData.page_header_description}}</p> -->
            </div>
            </div>
        </div>
        <div class="main-slider-container">
            <div class="slider-container">
                <h2 class="slider-heading">{{getDonationData && getDonationData.main_content_1_title}}</h2>
                <p class="slider-content">{{ getDonationData && getDonationData.main_content_1_description }}</p>
                <!-- Carousel -->
                <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
                <!-- Dots Indicators -->
                <!-- <div class="carousel-indicators">
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>
                </div> -->
                <!-- Carousel Items -->

                </div>
                <carousel
                        class="exc-cat-carousel"
                        :perPage="5"
                        :loop="true"
                        :mouse-drag="true"
                        :autoplay="false"
                        :autoplayTimeout="3000"
                        paginationActiveColor="#117a7a"
                        paginationColor="#646769"
                        :paginationEnabled="isDesktop"
                        :perPageCustom="[[213, 3.5], [380, 3.3], [420, 3.6], [480, 4], [768, 4], [1200, 4], [1920, 4]]"
                        >

                        <slide
                            v-for="(item, index) in getDonationData && getDonationData.main_content_1_crousel_images"
                            :key="index"
                            class="exc-cat-slider"
                        >
                            <a
                                :href="item.image_redirect_link"
                                target="_blank"
                                rel="noopener noreferrer"
                                class="ml-2 mr-2"
                            >
                            <img
                                class="img-fluid"
                                :src="item.image"
                                :alt="`Image ${index + 1}`"
                            />
                            <img class="play-btn" src="https://tss-static-images.gumlet.io/play.svg"/>
                            </a>
                        </slide>
                    </carousel>
            </div>
            
        </div>

        <div class="container my-3">
            <h2 class="text-center mb-4 donation-heading">{{getDonationData && getDonationData.main_content_2_title}}</h2>
            <!-- Donation Table -->
            <div class="donation-container">
                <!-- Render header dynamically -->
                <div v-if="getDonationData && getDonationData.main_content_2_tabular_description && getDonationData.main_content_2_tabular_description.length" class="donation-header">
                <span>{{ getDonationData.main_content_2_tabular_description[0].column_1 }}</span>
                <span>{{ getDonationData.main_content_2_tabular_description[0].column_2 }}</span>
                </div>

                <!-- Render rows dynamically -->
                <div v-for="(item, index) in getDonationData && getDonationData.main_content_2_tabular_description && getDonationData.main_content_2_tabular_description.length && getDonationData.main_content_2_tabular_description.slice(1)" :key="index" class="donation-row">
                <span>{{ item.column_1 }}</span>
                <span>{{ item.column_2 }}</span>
                </div>
            </div>

            <!-- Disclaimer -->
            <div class="disclaimer">
            <p>{{ getDonationData && getDonationData.main_content_2_disclaimer }}</p>
            <p>{{ getDonationData && getDonationData.page_footer_contact_text }}</p>
            </div>
        </div>


        <div class="container-fluid stats-section" v-if="getDonationData.page_footer_icons">
            <div class="d-flex flex-wrap justify-content-between">
            <!-- Total Adoptions -->
            <div class="stat-block stat-adoptions" v-if="getDonationData.page_footer_icons[0]">
                <div class="stat-icon-number">
                    <img v-if="getDonationData.page_footer_icons[0].icon_image" :src="getDonationData.page_footer_icons[0].icon_image" alt="icon" class="stat-icon" />
                    <div class="stat-number" style="color: #FF0000;">{{getDonationData.page_footer_icons[0].icon_text_1}}</div>
                </div>
                <div class="stat-title">{{getDonationData.page_footer_icons[0].icon_text_2}}</div>
            </div>
            <!-- Total Rescues -->
            <div class="stat-block stat-rescues" v-if="getDonationData.page_footer_icons[1]">
                <div class="stat-icon-number">
                    <img style="margin-top: -5px;" v-if="getDonationData.page_footer_icons[1].icon_image" :src="getDonationData.page_footer_icons[1].icon_image" alt="icon" class="stat-icon" />
                <div class="stat-number" style="color: #0C8EFF;">{{getDonationData.page_footer_icons[1].icon_text_1}}</div>
                </div>
                <div style="margin-top: 5px;" class="stat-title">{{getDonationData.page_footer_icons[1].icon_text_2}}</div>
            </div>
            <!-- Sterilisations -->
            <div class="stat-block stat-sterilisations"  v-if="getDonationData.page_footer_icons[2]">
                <div class="stat-icon-number">
                    <img v-if="getDonationData.page_footer_icons[2].icon_image" :src="getDonationData.page_footer_icons[2].icon_image" alt="icon" class="stat-icon" />
                <div class="stat-number" style="color: #26A502;">{{getDonationData.page_footer_icons[2].icon_text_1}}</div>
                </div>
                <div class="stat-title">{{getDonationData.page_footer_icons[2].icon_text_2}}</div>
            </div>
            </div>
        </div>

        <!-- Sticky Donate Button -->
        <div class="sticky-button">
    <a 
        :href="getDonationData && getDonationData.page_header_button_redirect_link" 
        target="_blank" 
        class="donate-button-link"
        style="width: 100%;"
    >
        <button class="donate-button" @click="donate()">
            {{ getDonationData && getDonationData.page_header_button_text }}
        </button>
    </a>
</div>

    </div>
</template>
<script>
import {mapGetters} from 'vuex'

export default {
  name: 'AnimalDonation',
  data () {
    return {
      isDesktop: this.$parent.isDesktop
    }
  },
  created () {
    this.$store.dispatch('GET_DONATION_DATA_FROM_MOBILE_CMS')
  },
  computed: {
    ...mapGetters(['getDonationData', 'user'])
  },
  mounted () {
    setTimeout(() => {
      this.scrollToCampaignInfo()
    }, 300)
    this.$store.commit('MOENGAGE_EVENT', {
      eventName: 'VISIT_ANIMAL_DONATION_PAGE',
      payload: {
        UserId: this.user && this.user.user_id ? this.user.user_id : 0,
        Platform: 'WEB'
      }
    })
  },
  methods: {
    donate () {
      this.$store.commit('MOENGAGE_EVENT', {
        eventName: 'CLICK_DONATE_BUTTON',
        payload: {
          UserId: this.user && this.user.user_id ? this.user.user_id : 0,
          Platform: 'WEB'
        }
      })
    },
    scrollToCampaignInfo () {
    //   const imageElement = this.$refs.imageToScroll
      const headingElement = this.$refs.headingToScroll
      if (headingElement) {
        const viewportHeight = window.innerHeight
        const elementPosition =
          headingElement.getBoundingClientRect().top + window.scrollY

        // Scroll so that the heading aligns with the bottom of the viewport
        window.scrollTo({
          top: elementPosition - viewportHeight + (headingElement.offsetHeight + 100),
          behavior: 'smooth'
        })
      }
    }
  }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&family=Montserrat:ital,wght@0,100..900;1,100..900&family=Mulish:ital,wght@0,200..1000;1,200..1000&family=Open+Sans:ital,wght@0,300..800;1,300..800&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&family=Mulish:ital,wght@0,200..1000;1,200..1000&family=Open+Sans:ital,wght@0,300..800;1,300..800&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');
.main-slider-container{
    background-color: #FFF6F6;
}
.dogs-restling{
    position: relative;
    /* left: 48px; */
    left: 17%;
}
.dogs-restling img{
    width: 80% !important;
    height: 295px ;
}
.two-dog-cuddling{
    position: relative;
    left: 7%;
    top: 35px;
}
.two-dog-cuddling img{
    width: 80% !important ;
    height: 100%;
}
.cat-care{
    position: relative;
    left: 60px;
}
.cat-care img{
    width: 90% !important;
    height: 90% !important;
}
.exc-cat-slider {
  position: relative; /* Establish a positioning context */
}
.exc-cat-slider .play-btn {
  position: absolute; /* Position relative to the parent */
  top: 50%; /* Center vertically */
  left: 50%; /* Center horizontally */
  transform: translate(-50%, -50%); /* Offset to center */
  width: 50px; /* Adjust as needed for play button size */
  height: 50px; /* Adjust as needed for play button size */
  pointer-events: none; /* Prevent play button from interfering with link clicks */
}
.VueCarousel-slide {
    visibility: visible;
}
.donate-button:focus {
    outline: none; /* Remove focus outline */
    box-shadow: none; /* Remove any box-shadow added by the browser */
}
.slider-heading{
    font-family: 'Inter';
    color: #000000;
    margin-bottom: 10px;
    font-family: Inter;
    font-size: 34px;
    font-weight: 600;
    line-height: 41.15px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
}
.slider-content{
    font-family: 'Inter';
    color: #313131;
    font-size: 24px;
    font-weight: 500;
    line-height: 29.05px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

}
.donation-heading{
    font-family: 'Inter';
    font-size: 34px;
    font-weight: 500;
    line-height: 41.15px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #272727;

}
.banner {
    background-color: #F5F5F0;
    background-image: linear-gradient(90deg, rgba(0, 0, 0, 0.02) 1px, transparent 1px),
                    linear-gradient(rgba(0, 0, 0, 0.03) 1px, transparent 1px);
    background-size: 40px 45px;
    background-position: center;
    padding: 24px 20px;
    margin-bottom: 30px; /* Space for sticky button on mobile */
}
.banner-section {
    padding-left: 20px;
    padding-right: 20px;
}
.donate-button {
    background-color: #F06061;
    color: white;
    border: none;
    padding-top: 12px;
    padding-right: 48px;
    padding-bottom: 12px;
    padding-left: 48px;
    font-size: 16px;
    border-radius: 45px;
    display: block;
    text-align: center;
    font-family: 'Open Sans';
}

.donate-button:hover {
    background-color: #e73b4c;
}

.logo {
    text-align: center;
    margin-bottom: 20px;
}

.logo img {
    /* max-height: 60px; */
    width: 263px;
    height: 111px;
}
.image-grid img {
    border-radius: 40px;
    width: 100%;
    object-fit: cover; /* Ensures images are properly cropped */
    pointer-events: none;
}

.sticky-button {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
    padding: 10px 20px;
    background-color: #f9f9f9;
    box-shadow: 4px 4px 6px rgba(0, 0, 0, 0.1);
    display: none; /* Initially hidden */
}

.slider-container {
    text-align: center;
}
.slider-container h2 {
    margin-bottom: 10px;
}
.slider-container p {
    color: #313131; /* Muted text color */
    margin-bottom: 40px;
}
.carousel-item img {
    border-radius: 10px;
}
.donation-container {
    margin-top: 30px;
    background-color: #eae7e7;
    border-radius: 10px;
    /* padding: 20px; */
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
}

.donation-header {
    background-color: #AAAAAA;
    color: #FFFFFF;
    padding: 25px 40px;
    border-radius: 10px 10px 0 0;
    display: flex;
    justify-content: space-between;
    font-family: 'Inter';
    font-size: 24px;
    font-weight: 600;
    line-height: 29.05px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
}

.donation-row {
    font-family: 'Lato';
    font-size: 18px;
    font-weight: 500;
    line-height: 21.6px;
    text-align: left;
    color: #0F0F0F;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    padding: 25px 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #dbdde0;
    background-color: #F2F2F2;
}

.donation-row:first-child {
    border-top: none;
}

.disclaimer {
    font-family: 'Lato';
    font-size: 18px !important;
    font-weight: 500;
    line-height: 21.6px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin-top: 20px;
    color: #8C8C8C;
}

.stats-section {
    background-color: #ffeaea; /* Light pink background */
    padding: 20px 20px;
}

.stat-block {
    text-align: center;
    flex: 1;
}

.stat-icon-number {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
}

.stat-icon {
width: 63px;
height: 63px;
mix-blend-mode: darken;
background-color: #FFF4F4;
}

.stat-number {
    font-family: 'Lato';
    font-size: 40.32px !important;
    font-weight: 700;
    line-height: 57.99px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
}

.stat-title {
    font-size: 16px;
    font-family: Lato;
    font-size: 32px;
    font-weight: 600;
    line-height: 38.4px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    font-weight: 600;
    /* margin-top: 5px; */
    color: #323232;
}

.stat-adoptions .stat-icon {
    color: red;
}

.stat-rescues .stat-icon {
    color: blue;
}

.stat-sterilisations .stat-icon {
    color: green;
}

.exc-cat-carousel {
    padding-left: 10px !important
}

.VueCarousel {
    display: inline-flex !important;
}
.VueCarousel-slide {
    flex-basis:initial !important;
}
@media (max-width: 1080px) {
  .dogs-restling img{
    height: 210px !important;
  }
  .two-dog-cuddling {
    left: 5%;
  }
  .cat-care {
    left: 50px;
  }
}

@media (max-width: 990px) {
  .cat-care {
    left: 45px;
  }
  .two-dog-cuddling {
    left: 7%;
  }
}
@media (max-width: 767px) {
    /** Mobile View*/
    .donation-row {
        padding: 10px;
    }
    .slider-container p {
        color: #313131; /* Muted text color */
        margin-bottom: 25px;
    }
    .stats-section {
        background-color: #ffeaea; /* Light pink background */
        padding: 15px 20px;
    }
    .banner {
        padding: 2px 20px;
        margin-bottom: 12px; /* Adjust margin to make room for sticky button */
    }
    .image-grid {
        order: 2;
        margin-bottom: 20px;
        pointer-events: none;
    }

    .exc-cat-slider .play-btn {
        width: 27px; 
        height: 27px;
    }

    .heading {
        order: 3;
        text-align: center;
        margin-bottom: 10px;
    }
    .heading h1 {
        color: #272727  !important;
        font-family: 'Lato'  !important;
        font-size: 24px !important;
        font-weight: 600  !important; 
        line-height: 24px  !important;
        text-align: center;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
    }
    .description {
        order: 4;
        color: #8C8C8C;
        text-align: center;
        margin-bottom: 20px;
        font-family: 'Lato';
        font-size: 12px;
        font-weight: 600;
        line-height: 14.4px;
        text-align: center;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;

    }
    .stat-icon {
    width: 30px;
    height: 30px;
}
    .slider-heading{
        font-family: 'Lato';
        font-size: 16px;
        font-weight: 600;
        line-height: 19.2px;
        text-align: center;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;

    }
    .slider-content{
        font-family: 'Lato';
    font-size: 12px;
    font-weight: 500;
    line-height: 10px;
    text-align: center;
    color: #313131;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    }
    .donation-heading{
        font-family: 'Lato';
        color: #272727;
    font-size: 16px;
    font-weight: 500;
    line-height: 19.2px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin-bottom: 15px !important;
    }
    .donation-header {
        padding-top:5.1px;
        padding-right: 17.85px;
        padding-bottom: 5.1px;
        padding-left:17.85px;
        border-radius:8.5px 8.5px 0 0;

        font-family: 'Lato';
        font-size: 14px;
        font-weight: 600;
        line-height: 16.8px;
        text-align: center;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;

    }
    .stat-icon-number {
    gap: 2px ;
}
    .sticky-button {
        width: 100%;
        display: flex; /* Show sticky button on mobile */
        justify-content: center;
    }

    .donate-button {
        width: 104%;
        border-radius: 6px;
        margin-left: -7px;
    }
    .donation-row{
        font-family: 'Lato';
        font-size: 12px;
        font-weight: 500;
        line-height: 14.4px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;

    }
    .img-fluid {
        width: 99px;
        border-radius: 2.95px;
        height: 136px;
        object-fit: cover;
    }
    .dogs-restling{
    position: relative;
    /* left: 48px; */
    left: 3%;
}
.disclaimer {
    font-family: 'Lato';
    font-size: 11px !important;
    font-weight: 500;
    line-height: 13.2px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin-left: 10px;
}
.stat-number {
    font-family: 'Lato';
font-size: 16px !important;
font-weight: 700;
line-height: 19.2px;
text-align: center;
text-underline-position: from-font;
text-decoration-skip-ink: none;

}
.stat-title {
    font-family: 'Lato';
    font-size: 11px;
    font-weight: 600;
    line-height: 13.2px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

}
.dogs-restling img {
    width: 97% !important;
    height: 170px !important;
}
.two-dog-cuddling {
    position: relative;
    left: 3%;
    top: 38px;
}
.two-dog-cuddling img {
    width: 160px !important;
    height: 100%;
}
.cat-care {
    position: relative;
    left: -1%;
    /* left: 20px; */
}
.cat-care img{
    height: 100% !important;
    max-height: 138px !important;
    /* height: 80% !important; */
}
.image-grid img {
    border-radius: 40px;
    /* width: 90%;
    height: 150px; */
    object-fit: cover; /* Ensures images are properly cropped */
    pointer-events: none;
}
.main-slider-container{
    padding-top: 16px;
    padding-bottom: 16px;
}
.donation-container {
    margin: 0 10px;
}
.exc-cat-carousel .carousel-pagination,
    .exc-cat-carousel .slick-dots {
        display: none !important;
    }
    .VueCarousel-pagination {
        display: none !important;
    }
}

@media (min-width: 768px) {
    /** Desktop View*/
    .logo {
        margin-bottom: 40px;
    }
    .heading {
        text-align: left;
        line-height: 74px;
        display: inline-block;
        word-wrap: break-word;
        font-family: 'Lato';
        font-weight: 600;
        font-size: 64px;
        color: #272727;
    }
    .description {
      font-family: 'Lato';
      font-weight: 600;
      font-size: 20px;
      line-height: 28px;
      color:#6B6B6B;
      margin-top:10px;
      margin-bottom: 25px;
    }
    .donate-button{
        font-family: 'Open Sans';
        width: 286px;
        height: 74px;
        font-size: 24px;
        line-height: 32.68px;
        font-weight: 600;
    }
    .img-fluid {
        width: 338px;
        border-radius: 10px;
        height: 464px;
        object-fit: cover;
    }
    .main-slider-container{
      padding-top: 36px;
      padding-bottom: 36px;
    }
    .slider-heading{
        font-weight: 600;
        font-size: 34px;
        line-height: 41.5px;
    }
    .slider-content{
        font-weight: 500;
        font-size: 24px;
        line-height: 29.5px;
    }
}
</style>



// WEBPACK FOOTER //
// AnimalDonation.vue?063417de